<r-widget-control [control]="firstnameControl">
  <nz-input-number
    [name]="config.name"
    [nzPlaceHolder]="config.placeholder"
    [(ngModel)]="config.value"
    (ngModelChange)="onChange($event)"
    [nzMin]="config.min"
    [nzMax]="config.max"
    [nzStep]="config.step"
    [required]="config.required"
    [disabled]="config.disabled"
    ngDefaultControl
    #firstnameControl="ngModel"
    style="width: 100%"
  ></nz-input-number>
</r-widget-control>
